
import React, { useEffect, useState } from 'react';
import { MdOutlineBlock, MdSearch, MdEdit, MdDelete, MdRemoveRedEye, MdMode } from "react-icons/md";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import addPhoto from '../../assets/image/addphoto.svg';

import Loader from '../../Components/Loader/Loader'

function SubAdminCreate() {
    const [name, setname] = useState('')
    const [email, setEmail] = useState('')
    const [number, setNumber] = useState('')
    const [password, setpassword] = useState('')
    const [regionList, setRegionList] = useState([]);
    const [regionId, setRegionId] = useState("");
    const [countryList, setCountryList] = useState([]);
    const [roleId, setroleId] = useState()
    const [rolelist, setrolelist] = useState([])
    const [countryId, setCountryId] = useState("");
    const [stateList, setStateList] = useState([]);
    const [stateId, setStateId] = useState("");
    const [districtList, setDistrictList] = useState([]);
    const [districtId, setDistrictId] = useState("");
    const [blockList, setBlockList] = useState([]);
    const [blockId, setBlockId] = useState("");
    const location = useLocation()
    const [country__code,setCountryCode]=useState("")
    const [emailErr, setEmailErr] = useState("")

    const [id, setId] = useState("")
    const [status, setStatus] = useState(false)
    const navigate = useNavigate();
    const [global, setGloble] = useState(0); // default to 0
    const [isChecked, setIsChecked] = useState(false);
    useEffect(() => {
        setId(location?.state?.state?.id)

    }, [])
    useEffect(() => {
        if (location?.state?.state?.Status) {
            subadminview()
            setStatus(true)
        }
    }, [])
    const [image, setImage] = useState(null);
    const [file, setFile] = useState()
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
        }
        setFile(file)
    };
    const [nameErr, setNameErr] = useState("");
    const [numberErr, setNumberErr] = useState("");
    const [passwordErr, setPasswordErr] = useState("");
    console.log(location?.state?.state, "data")
    const handleNameChange = (e) => {
        let value = e.target.value;
    
        // Remove any leading non-alphanumeric characters (spaces, special characters, etc.)
        value = value.replace(/^[^a-zA-Z0-9]+/, "");
    
        setname(value);
        setNameErr("");
    };
    const handleNumberChange = (e) => {
        const value = e.target.value;
        if (/^\d{0,17}$/.test(value)) {
            setNumber(value);
            setNumberErr("");
        } else {
            setNumberErr("Only numbers allowed, max length 17.");
        }
    };
    const goBack = () => {
        localStorage.setItem("Role", "SubAdmins")
        navigate(-1); // Navigates back to the previous page

    };
    const handlePasswordChange = (e) => {
        const value = e.target.value;
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;

        if (!passwordRegex.test(value)) {
            setPasswordErr("Password must be 8-16 characters with at least one letter, number, and special character.");
        } else {
            setPasswordErr("");
        }
        setpassword(value);
    };
    useEffect(() => { getRegionList(); }, []);


    const [bt, setbt] = useState(false)
    const createSubAdmin = async (e) => {
        setbt(true)
        e.preventDefault();
        // Validation
        if (!name.trim()) return toast.warning("Name is required"), setbt(false);
        if(!country__code?.trim()) return toast.warning("Country Code is required"), setbt(false);
        if (!number.trim()) return toast.warning("Phone number is required"), setbt(false);
        if (!email.trim()) return toast.warning("Email is required"), setbt(false);
        if (!password.trim()) return toast.warning("Password is required"), setbt(false);
        if (!roleId) return toast.warning("Role is required"), setbt(false);
        // Password validation
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/;
        if (!passwordRegex.test(password)) {
            return toast.warning("Password must be 8-16 characters long, with at least one letter, one number, and one special character."), setbt(false);
        }
        const locationPermissionPayload = filterGroups.map(group => {
            const payload = {};
            if (Array.isArray(group.regionId) && group.regionId.length > 0) {
                payload.region_id = group.regionId[0];
            } else if (group.regionId?.trim?.()) {
                payload.region_id = group.regionId;
            }
        
            if (Array.isArray(group.countryId) && group.countryId.length > 0) {
                payload.country_id = group.countryId[0];
            } else if (group.countryId?.trim?.()) {
                payload.country_id = group.countryId;
            }
        
            if (Array.isArray(group.stateId) && group.stateId.length > 0) {
                payload.state_id = group.stateId[0];
            } else if (group.stateId?.trim?.()) {
                payload.state_id = group.stateId;
            }
            return payload;
        });
        // Creating a new FormData object
        const formData = new FormData();
        formData.append("email", email);
        formData.append("password", password);
        formData.append("role_id", roleId);
        formData.append("is_global", global);
        formData.append("full_name", name);
        formData.append("phone", number);
        formData.append("country_code",country__code)
        if (file) {
            formData.append("subAdminProfile", file);
        }
        if (global === 0) {
            formData.append("location_permission", JSON.stringify(locationPermissionPayload))
        }


        try {
            const response = await handleApiCall("POST", `${endpoint.createSubAdmin}`, formData);
            console.log(response, "===========>>>>");

            if (response?.data?.code === 200) {
                localStorage.setItem("Location", "SubAdmins")
                toast.success(response?.data?.message);  // Show success toast message
                setbt(false)
                setTimeout(() => {
                    goBack()
                }, 1000);
            } else {
                toast.error(response?.response?.data?.errorMessage || "An error occurred");
                setbt(false)
            }
        } catch (error) {
            setbt(false)
            toast.error(error?.response?.data?.errorMessage || "An error occurred");
        } finally {
            setbt(false);
        }
    };
    const updateSubAdmin = async (e) => {
        setbt(true)
        e.preventDefault();
        // Validation
        if (!name?.trim()) return toast.warning("Name is required"), setbt(false);
        if(!country__code?.trim()) return toast.warning("Country Code is required"), setbt(false);
        if (!number?.trim()) return toast.warning("Phone number is required"), setbt(false);
        if (!email?.trim()) return toast.warning("Email is required"), setbt(false);

        if (!roleId) return toast.warning("Role is required"), setbt(false);
        // Password validation
        const locationPermissionPayload = filterGroups.map(group => {
            const payload = {};
            if (group.permission?.trim()) payload.location_id = group.permission;
        
            if (Array.isArray(group.regionId) && group.regionId.length > 0) {
                payload.region_id = group.regionId[0]; // take first item if it's an array
            } else if (group.regionId?.trim?.()) {
                payload.region_id = group.regionId;
            }
        
            if (Array.isArray(group.countryId) && group.countryId.length > 0) {
                payload.country_id = group.countryId[0];
            } else if (group.countryId?.trim?.()) {
                payload.country_id = group.countryId;
            }
        
            if (Array.isArray(group.stateId) && group.stateId.length > 0) {
                payload.state_id = group.stateId[0];
            } else if (group.stateId?.trim?.()) {
                payload.state_id = group.stateId;
            }
        
            return payload;
        });
        
        const locationPermissionPayloadnew = newFilterGroups.map(group => {
            const payload = {};
        
            if (Array.isArray(group.regionId) && group.regionId.length > 0) {
                payload.region_id = group.regionId[0];
            } else if (group.regionId?.trim?.()) {
                payload.region_id = group.regionId;
            }
        
            if (Array.isArray(group.countryId) && group.countryId.length > 0) {
                payload.country_id = group.countryId[0];
            } else if (group.countryId?.trim?.()) {
                payload.country_id = group.countryId;
            }
        
            if (Array.isArray(group.stateId) && group.stateId.length > 0) {
                payload.state_id = group.stateId[0];
            } else if (group.stateId?.trim?.()) {
                payload.state_id = group.stateId;
            }
        
            return payload;
        });
        // Creating a new FormData object
        const formData = new FormData();
        formData.append("id", id);
        formData.append("email", email);
        formData.append("password", password);
        formData.append("role_id", roleId);
        formData.append("is_global", global);
        formData.append("full_name", name);
        formData.append("phone", number);
        formData.append("country_code",country__code)
        if (file) {
            formData.append("subAdminProfile", file);
        }

        if (global === 0) {
            formData.append("location_permission_add", JSON.stringify(locationPermissionPayloadnew))
            formData.append("location_permission_edit", JSON.stringify(locationPermissionPayload))
            formData.append("location_permission_delete", JSON.stringify(locationPermissionDelete))
        }
        
        try {
            const response = await handleApiCall("POST", `${endpoint.updateSubAdmin}`, formData);
            console.log(formData, "===========>>>>");

            if (response?.data?.code === 200) {
                setbt(false)
                toast.success(response?.data?.message);  // Show success toast message
                setTimeout(() => {
                    goBack()
                }, 1000);
            } else {
                toast.error(response?.response?.data?.errorMessage || "An error occurred");
                setbt(false)
            }
        } catch (error) {
            setbt(false);
            toast.error(error?.response?.data?.errorMessage || "An error occurred");
        } finally {
            setbt(false);
        }
    };

    const urlToFile = async (url) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const fileName = url.split("/").pop();
            return new File([blob], fileName, { type: blob.type });
        } catch (error) {
            console.error("Error fetching image:", error);
        }
    };

    const convertAndSetFile = async () => {
        console.log("Location State:", location?.state); // Debugging
        console.log("Image URL:", location?.state?.item?.image); // Debugging

        if (!location?.state?.item?.image) {
            console.error("Image URL is undefined or missing.");
            return;
        }

        try {
            const file = await urlToFile(location?.state?.item?.image);
            setFile(file); // Store file in state
            console.log("File stored:", file); // Debugging
        } catch (error) {
            console.error("Error converting URL to file:", error);
        }
    };
    const subadminview = async () => {
        setbt(true)
        try {
            const response = await handleApiCall("get", `${endpoint.SubAdminView}?id=${location?.state?.state?.id}`);
            console.log(response, "=======SubAdinView");

            if (response?.data?.success) {
                setbt(false)
                const subAdmin = response.data.data.subAdmin;
                const { image, full_name, phone, email, password, is_global, role_id, country_code,_id, region_id, country_id, state_id, district_id } = subAdmin;

                // Set main subadmin fields
                setFile(image)
                setImage(image);
                setId(_id);
                setname(full_name);
                setEmail(email);
                setNumber(phone);
                setpassword(password);
                setGloble(is_global);
                setroleId(role_id);
                setRegionId(region_id);
                setCountryId(country_id);
                setCountryCode(country_code)
                setStateId(state_id);
                setDistrictId(district_id);

                if (is_global === 1) setIsChecked(true);

                // Handle permissions
                const permissionList = response.data.data.permission || [];

                const updatedGroups = await Promise.all(
                    permissionList.map(async (item) => {
                        const regionId = item.region_id?._id || "";
                        const countryId = item.country_id?._id || "";
                        const stateId = item.state_id?._id || "";
                        const permission = item?._id
                        let countryList = [];
                        let stateList = [];

                        // Fetch country list based on regionId
                        if (regionId) {
                            const countryRes = await handleApiCall("get", `${endpoint.countryList}?region_id=${regionId}`);
                            if (countryRes?.data?.code === 200) {
                                countryList = countryRes.data.data;
                            }
                        }

                        // Fetch state list based on countryId
                        if (countryId) {
                            const stateRes = await handleApiCall("get", `${endpoint.stateList}?country_id=${countryId}`);
                            if (stateRes?.data?.code === 200) {
                                stateList = stateRes.data.data;
                            }
                        }

                        return {
                            regionId,
                            countryId,
                            stateId,
                            countryList,
                            stateList,
                            permission
                        };
                    })
                );

                setFilterGroups(updatedGroups);
            }

            if (response?.response?.data?.success === false) {
                setbt(false)
                toast.error(response?.response?.data?.message);
            }
        } catch (e) {
            console.error("SubAdmin View error:", e);

        }
    };



    useEffect(() => {
        getRoleList()
    }, [])

    const getRoleList = async () => {
        const response = await handleApiCall("get", `${endpoint.subAdminRole}`, {

        });

        try {
            if (response?.data?.code === 200) {
                setrolelist(response?.data?.data?.roleList)
                console.log("RoleList--------", response)

            }

            if (response?.response?.data?.success === false) {
                console.log(response?.response?.data?.message, "")

                toast.error(response?.response?.data?.message)
                // setTimeout(() => { navigate("/") }, 2000)
            }
        } catch (e) {
            console.log("=============>", e)
        }
    }

    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterRegion}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
            else toast.error(response?.response?.data?.message);
        } catch (e) { console.log("Error fetching region list:", e); }
    };

    const [filterGroups, setFilterGroups] = useState([
        {
            regionId: "",
            countryId: [],
            stateId: [],
            countryList: [],
            stateList: [],
            permission: ""

        }
    ]);
    const resetFilterGroups = () => {
        if (status && isChecked) {
            // subadminview(); // ✅ Always call the API if status and isChecked are true

            if (newFilterGroups.length > 0) {
                setNewFilterGroups([
                    {
                        regionId: "",
                        countryId: "",
                        stateId: "",
                        countryList: [],
                        stateList: [],
                        permission: ""
                    }
                ]);
            }
        } else if (isChecked) {
            subadminview(); 
            setFilterGroups([
                {
                    regionId: "",
                    countryId: "",
                    stateId: "",
                    countryList: [],
                    stateList: [],
                    permission: ""
                }
            ]);
        }
    };

    const [newFilterGroups, setNewFilterGroups] = useState([]);

    const handleAddMore = () => {
        if (isChecked) return resetFilterGroups();

        const newGroup = {
            regionId: "",
            countryId: "",
            stateId: "",
            countryList: [],
            stateList: [],
            permission: ""
        };

        if (status) {
            setNewFilterGroups(prev => [...prev, newGroup]);
        } else {
            setFilterGroups(prev => [...prev, newGroup]);
        }
    };

    const handleRegionChange = async (index, regionId, isNew = false) => {
        const list = isNew ? [...newFilterGroups] : [...filterGroups];
        const update = isNew ? setNewFilterGroups : setFilterGroups;

        list[index].regionId = regionId;
        list[index].countryId = "";
        list[index].stateId = "";
        list[index].countryList = [];
        list[index].stateList = [];
        update(list);

        if (!regionId) return;

        try {
            const res = await handleApiCall("get", `${endpoint.filterCountry}?region_id=${JSON.stringify(regionId)}`);
            if (res?.data?.code === 200) {
                list[index].countryList = res.data.data;
                update([...list]);
            }
        } catch (e) {
            console.error("Failed to fetch countries", e);
        }
    };

    const handleCountryChange = async (index, countryId, isNew = false) => {
        const list = isNew ? [...newFilterGroups] : [...filterGroups];
        const update = isNew ? setNewFilterGroups : setFilterGroups;

        list[index].countryId = countryId;
        list[index].stateId = "";
        list[index].stateList = [];
        update(list);

        try {
            const res = await handleApiCall("get", `${endpoint.filterState}?country_id=${JSON.stringify(countryId)}`);
            if (res?.data?.code === 200) {
                list[index].stateList = res.data.data;
                update([...list]);
            }
        } catch (e) {
            console.error("Failed to fetch states", e);
        }
    };

    const handleStateChange = (index, stateId, isNew = false) => {
        const list = isNew ? [...newFilterGroups] : [...filterGroups];
        const update = isNew ? setNewFilterGroups : setFilterGroups;

        list[index].stateId = stateId;
        update(list);
    };

    const [locationPermissionDelete, setLocationPermissionDelete] = useState([]);
    
    const handleDeleteGroup = (index, isNew = false) => {
        const listToUpdate = isNew ? newFilterGroups : filterGroups;
        const setList = isNew ? setNewFilterGroups : setFilterGroups;

        const removedGroup = listToUpdate[index];

        if (!isNew && removedGroup?.permission) {
            setLocationPermissionDelete(prev => [...prev, { location_id: removedGroup.permission }]);
        }

        const updatedGroups = listToUpdate.filter((_, i) => i !== index);
        setList(updatedGroups);
    };


    console.log(filterGroups, locationPermissionDelete, newFilterGroups, "All list data view")

    


    return (
        <>
            <Loader isLoading={bt} /> {/* Call Loader */}
            <form className="common-table-wrapper m-0 " >
                <div className="flex items-start gap-4">
                    {/* Hidden File Input */}
                    <input
                        type="file"
                        id="fileInput"
                        className="hidden"
                        accept="image/*"
                        onChange={handleImageChange}
                    />

                    {/* Label acts as a button */}
                    <label
                        htmlFor="fileInput"
                        className="flex items-center justify-center w-20 h-20 rounded-full border border-black cursor-pointer"
                    >
                        {image ? (
                            <img
                                src={image}
                                alt="Selected"
                                className="w-full h-full rounded-full object-cover"
                            />
                        ) : (
                            <img
                                src={addPhoto}
                                className=" object-cover p-2"></img>
                        )}
                    </label>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2 pb-3 mt-2 ">
                    <div>
                        <input
                            type="text"
                            placeholder="Name"
                            required
                            value={name}
                            onChange={handleNameChange}
                            className="p-2 bg-[#F6F6F6]  border-[1px] border-black  rounded-md focus:outline-none w-full "
                        />
                        {nameErr && <p className="text-red-500 text-xs mt-1">{nameErr}</p>}
                    </div>
                    <input
                        type="text"
                        placeholder="Country Code"
                        required
                        maxLength={5}
                        value={country__code}
                        onChange={(e) => {
                            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
                            if (/^[+0-9,]*$/.test(value)) { // Only allow numbers, plus, and commas
                                setCountryCode(value);
                            }
                        }}
                        className="p-2 bg-[#F6F6F6] border-[1px] border-black rounded-md focus:outline-none w-full h-full"
                    />
                    <div>
                        <input
                            type="text"
                            placeholder="Phone Number"
                            required
                            maxLength={15}
                            value={number}
                            onChange={handleNumberChange}
                            className="p-2 bg-[#F6F6F6]  border-[1px] border-black  rounded-md focus:outline-none w-full "
                        />
                        {numberErr && <p className="text-red-500 text-xs mt-1">{numberErr}</p>}
                    </div>
                    <div>
                        <input
                            type="email"
                            placeholder="Email"
                            required
                            value={email}
                            onKeyPress={(e) => {
                                // Prevent space key from being typed
                                if (e.key === " " || e.code === "Space") {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                let value = e.target.value.replace(/\s/g, ''); // Remove spaces

                                // Email format validation
                                if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                                    setEmailErr("Please enter a valid email.");
                                } else {
                                    setEmailErr('');
                                }

                                setEmail(value); // Set value without spaces
                            }}
                            className="p-2 bg-[#F6F6F6]  border-[1px] border-black  rounded-md focus:outline-none w-full"
                        />
                        {emailErr && <p className="text-red-500 text-xs mt-1">{emailErr}</p>}
                    </div>
                    <div>
                        <input
                            type="password"
                            placeholder="Password"
                            required
                            max={16}
                            value={password}
                            onChange={handlePasswordChange}
                            className="p-2 bg-[#F6F6F6]  border-[1px] border-black  rounded-md focus:outline-none w-full "
                        />
                        {passwordErr && <p className="text-red-500 text-xs mt-1 text-wrap break-words">{passwordErr}</p>}
                    </div>
                </div>
                {localStorage.getItem("roletype") === "Admin" ? <div className="flex gap-2 px-2 pb-2 items-center">
                    <input
                        type="checkbox"
                        className="w-5 h-5"
                        checked={isChecked}
                        onChange={(e) => {
                            const checked = e.target.checked;
                            setIsChecked(checked);
                            setGloble(checked ? 1 : 0);
                            resetFilterGroups(); // reset when checked
                        }}
                    />
                    <span className=" text-[#994263]">Global Admin</span>
                </div> : null}

                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 px-2 py-1 my-3 ">
                    <select required value={roleId} onChange={(e) => setroleId(e.target.value)} className="p-2 bg-[#F6F6F6]  font-bold border-[1px] border-black  rounded-md focus:outline-none w-full h-full">
                        <option value="" disabled selected>
                            Choose Role
                        </option>
                        {rolelist?.length > 0 && rolelist.map(item => (
                            <option key={item?._id} value={item?._id}>{item?.role}</option>
                        ))}
                    </select>
                </div>

                {filterGroups?.map((group, index) => (
                    <div key={`filter-${index}`} className="grid grid-cols-1 md:grid-cols-4 gap-4 px-3 py-3 bg-[#E5DED4] rounded-lg mt-3 relative">
                        {!isChecked && (
                            <div className="absolute right-3 top-3">
                                {filterGroups.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => handleDeleteGroup(index, false)} // false → not new
                                        className="text-red-600 font-bold text-sm px-3 py-1 border border-red-400 rounded hover:bg-red-100 transition"
                                    >
                                        Delete
                                    </button>
                                )}
                            </div>
                        )}

                        {global === 1 ? (
                            <div className="col-span-4 text-center font-bold text-red-600">
                                Course is globally accessible — location filters are blocked.
                            </div>
                        ) : (
                            <>
                                <select
                                    required
                                    value={group.regionId}
                                    onChange={(e) => handleRegionChange(index, [e.target.value], false)} // 👈 wrap in array
                                    className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                >
                                    <option value="" disabled>Choose Region</option>
                                    {regionList.map(item => (
                                        <option key={item._id} value={item._id}>{item.name}</option>
                                    ))}
                                </select>

                                {group.regionId && (
                                    <select
                                        required
                                        value={group.countryId}
                                        onChange={(e) => handleCountryChange(index, [e.target.value], false)}
                                        className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                    >
                                        <option value="" disabled>Choose Country</option>
                                        {group.countryList?.map(item => (
                                            <option key={item._id} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                )}

                                {group.countryId && (
                                    <select
                                        required
                                        value={group.stateId}
                                        onChange={(e) => handleStateChange(index, e.target.value, false)}
                                        className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                    >
                                        <option value="" disabled>Choose State</option>
                                        {group.stateList?.map(item => (
                                            <option key={item._id} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                )}
                            </>
                        )}
                    </div>
                ))}

                {/* NEW FILTER GROUPS IF status === true */}
                {newFilterGroups?.map((group, index) => (
                    <div key={`new-${index}`} className="grid grid-cols-1 md:grid-cols-4 gap-4 px-3 py-3 bg-[#D7E5D4] rounded-lg mt-3 relative">
                        {!isChecked && (
                            <div className="absolute right-3 top-3">
                                <button
                                    type="button"
                                    onClick={() => handleDeleteGroup(index, true)} // true → new group
                                    className="text-red-600 font-bold text-sm px-3 py-1 border border-red-400 rounded hover:bg-red-100 transition"
                                >
                                    Delete
                                </button>
                            </div>
                        )}
                        {global === 1 ? (
                            <div className="col-span-4 text-center font-bold text-red-600">
                                Course is globally accessible — location filters are blocked.
                            </div>
                        ) : (

                            <>
                                <select
                                    required
                                    value={group.regionId}
                                    onChange={(e) => handleRegionChange(index, [e.target.value], true)}
                                    className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                >
                                    <option value="" disabled>Choose Region</option>
                                    {regionList.map(item => (
                                        <option key={item._id} value={item._id}>{item.name}</option>
                                    ))}
                                </select>

                                {group.regionId && (
                                    <select
                                        required
                                        value={group.countryId}
                                        onChange={(e) => handleCountryChange(index, [e.target.value], true)}
                                        className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                    >
                                        <option value="" disabled>Choose Country</option>
                                        {group.countryList?.map(item => (
                                            <option key={item._id} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                )}

                                {group.countryId && (
                                    <select
                                        required
                                        value={group.stateId}
                                        onChange={(e) => handleStateChange(index, e.target.value, true)}
                                        className="p-2 bg-[#F6F6F6] font-bold border border-black rounded-md focus:outline-none w-full h-full"
                                    >
                                        <option value="" disabled>Choose State</option>
                                        {group.stateList?.map(item => (
                                            <option key={item._id} value={item._id}>{item.name}</option>
                                        ))}
                                    </select>
                                )}
                            </>
                        )}
                    </div>
                ))}

                <div className="flex justify-end px-3 py-2">
                    <button disabled={isChecked} onClick={handleAddMore} className="text-[#994263] text-[17px] font-bold cursor-pointer">
                        + Add More
                    </button>
                </div>

                <div className=' flex gap-3 mx-2 mt-10'>
                    <div
                        onClick={goBack}
                        className="  text-black  font-bold inline-flex cursor-pointer justify-center px-4 ms-2 items-center hover:bg-[#F6F6F6] border-black rounded-md border-[2px] py-2"
                    >
                        Cancel
                    </div>
                    <button
                        type="button"
                        disabled={bt}
                        onClick={status ? updateSubAdmin : createSubAdmin}
                        className="text-white bg-[#994263] px-5 font-bold inline-flex cursor-pointer justify-center ms-2 items-center py-2 hover:bg-[#e6e0e2] hover:text-black border-[#994263] rounded-md border-[2px]"
                    >
                        {bt ? "Requesting..." : status ? "Update" : "Add"}
                    </button>
                </div>
            </form>
            <Toastify />
        </>
    )
}

export default SubAdminCreate
